<template>
  <main>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <!-- <li><router-link to="/access">アクセス</router-link></li> -->
          <li><router-link to="/access">{{ accesstList.acf?.page_title }}</router-link></li>
        </ul>
      </div>
    </div>
    <div class="access">
      <div class="container">
        <h2 class="page--title">ACCESS<span>アクセス</span></h2>
        <!-- <AccessMenu :accessMenuChild="accessMenu" /> -->
        <!-- <ul class="access__tab tabs">
          <li class="access__tab__item tab-link" :class="isActive === 'バスをご利用の方' ? 'current' : ''" @click="isActiveF('バスをご利用の方')">
            <a class="tablinks">バスをご利用の方</a>
          </li>
          <li class="access__tab__item tab-link" :class="isActive === '東京BRTの詳細ルート' ? 'current' : ''" @click="isActiveF('東京BRTの詳細ルート')">
            <a class="tablinks">東京BRTをご利用の方</a>
          </li>
          <li class="access__tab__item tab-link" :class="isActive === '電車をご利用の方' ? 'current' : ''" @click="isActiveF('電車をご利用の方')">
            <a class="tablinks">電車をご利用の方</a>
          </li>
          <li class="access__tab__item tab-link" :class="isActive === 'コミュニティサイクルをご利用の方' ? 'current' : ''" @click="isActiveF('コミュニティサイクルをご利用の方')">
            <a class="tablinks">コミュニティサイクルをご利用の方</a>
          </li>
          <li class="access__tab__item tab-link">
            <a href="" class="tablinks">船をご利用の方</a>
          </li>
        </ul> -->
        <ul class="access__tab tabs" v-if="!isLoading">
          <li v-if="accesstList.acf?.large_title_2" :id="`tab_${accesstList.acf?.large_title_2}`" class="access__tab__item tab-link" @click="isActiveF(`${accesstList.acf?.large_title_2}`)">
            <a class="tablinks">{{ accesstList.acf?.large_title_2 }}</a>
          </li>
          <li v-if="accesstList.acf?.large_title_3" :id="`tab_${accesstList.acf?.large_title_3}`" class="access__tab__item tab-link" @click="isActiveF(`${accesstList.acf?.large_title_3}`)">
            <a class="tablinks">{{ accesstList.acf?.large_title_3 }}</a>
          </li>
          <li v-if="accesstList.acf?.large_title_4" :id="`tab_${accesstList.acf?.large_title_4}`" class="access__tab__item tab-link" @click="isActiveF(`${accesstList.acf?.large_title_4}`)">
            <a class="tablinks">{{ accesstList.acf?.large_title_4 }}</a>
          </li>
          <li v-if="accesstList.acf?.large_title_5" :id="`tab_${accesstList.acf?.large_title_5}`" class="access__tab__item tab-link" @click="isActiveF(`${accesstList.acf?.large_title_5}`)">
            <a class="tablinks">{{ accesstList.acf?.large_title_5 }}</a>
          </li>
          <li v-if="accesstList.acf?.large_title_6" :id="`tab_${accesstList.acf?.large_title_6}`" class="access__tab__item tab-link" @click="isActiveF(`${accesstList.acf?.large_title_6}`)">
            <a class="tablinks">{{ accesstList.acf?.large_title_6 }}</a>
          </li>
          <li v-if="accesstList.acf?.large_title_7" :id="`tab_${accesstList.acf?.large_title_7}`" class="access__tab__item tab-link" @click="isActiveF(`${accesstList.acf?.large_title_7}`)">
            <a class="tablinks">{{ accesstList.acf?.large_title_7 }}</a>
          </li>
          <li v-if="accesstList.acf?.large_title_8" :id="`tab_${accesstList.acf?.large_title_8}`" class="access__tab__item tab-link" @click="isActiveF(`${accesstList.acf?.large_title_8}`)">
            <a class="tablinks">{{ accesstList.acf?.large_title_8 }}</a>
          </li>
          <li v-if="accesstList.acf?.large_title_9" :id="`tab_${accesstList.acf?.large_title_9}`" class="access__tab__item tab-link" @click="isActiveF(`${accesstList.acf?.large_title_9}`)">
            <a class="tablinks">{{ accesstList.acf?.large_title_9 }}</a>
          </li>
          <li v-if="accesstList.acf?.large_title_10" :id="`tab_${accesstList.acf?.large_title_10}`" class="access__tab__item tab-link" @click="isActiveF(`${accesstList.acf?.large_title_10}`)">
            <a class="tablinks">{{ accesstList.acf?.large_title_10 }}</a>
          </li>
        </ul>
        <!-- <div style="width: 80%; margin: 0 auto 77px auto;">
          <PuSkeleton v-if="isLoading" :count="1" height="60px"/>
        </div>
        <div style="width: 80%; margin: 0 auto 35px auto;">
          <PuSkeleton v-if="isLoading" :count="1" height="40px"/>
        </div>
        <div style="width: 80%; margin: 0 auto 38px auto;">
          <PuSkeleton v-if="isLoading" :count="1" height="500px"/>
        </div>
        <div style="width: 80%; margin: 0 auto 35px auto;">
          <PuSkeleton v-if="isLoading" :count="1" height="40px"/>
        </div> -->
        <div class="tab-content" 
        :style="[accesstList.acf?.medium_title ||  accesstList.acf?.medium_subtitle || accesstList.acf?.medium_text_1 || accesstList.acf?.medium_text_2 ||
            accesstList.acf?.small_title_1 || accesstList.acf?.small_image_1 || accesstList.acf?.small_text_1 ||
            accesstList.acf?.small_title_2 || accesstList.acf?.small_image_2 || accesstList.acf?.small_text_2 ||
            accesstList.acf?.small_title_3 || accesstList.acf?.small_image_3 || accesstList.acf?.small_text_3 ||
            accesstList.acf?.small_title_4 || accesstList.acf?.small_image_4 || accesstList.acf?.small_text_4 ||
            accesstList.acf?.small_title_5 || accesstList.acf?.small_image_5 || accesstList.acf?.small_text_5 ||
            accesstList.acf?.small_title_6 || accesstList.acf?.small_image_6 || accesstList.acf?.small_text_6 ||
            accesstList.acf?.small_title_7 || accesstList.acf?.small_image_7 || accesstList.acf?.small_text_7 ||
            accesstList.acf?.small_title_8 || accesstList.acf?.small_image_8 || accesstList.acf?.small_text_8 ||
            accesstList.acf?.small_title_9 || accesstList.acf?.small_image_9 || accesstList.acf?.small_text_9 ||
            accesstList.acf?.small_title_10 || accesstList.acf?.small_image_10 || accesstList.acf?.small_text_10
      ] ? {'padding-bottom': '100px'} : {'padding-bottom': '0'}">
          <h2 class="access__title" style="text-align: center;" v-if="accesstList.acf?.page_title && !isLoading">{{ accesstList.acf?.page_title }}</h2>
          <div :ref='accesstList.acf?.large_title_1' :id='accesstList.acf?.large_title_1' class="access__content content--1 content-custom current" v-if="accesstList.acf?.large_title_1 || accesstList.acf?.large_text_1 || accesstList.acf?.large_image_1">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="accesstList.acf?.large_image_1 && !isLoading"
                :src="$func.formatUrl(accesstList.acf?.large_image_1)" 
                :alt="accesstList.acf?.large_title_1"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="accesstList.acf?.large_title_1 && !isLoading">{{ accesstList.acf?.large_title_1 }}</h2>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <p v-if="accesstList.acf?.large_text_1 && !isLoading" v-html="accesstList.acf?.large_text_1"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="accesstList.acf?.display_name_1">
              <a :href="accesstList.acf?.url_1" :target="accesstList.acf?.operation_at_transition_1 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ accesstList.acf?.display_name_1 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>

          <div :id="accesstList.acf?.large_title_2" class="access__content content--1 current" v-if="accesstList.acf?.large_title_2 || accesstList.acf?.large_text_2 || accesstList.acf?.large_image_2">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="accesstList.acf?.large_image_2 && !isLoading"
                :src="$func.formatUrl(accesstList.acf?.large_image_2)" 
                :alt="accesstList.acf?.large_title_2"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="accesstList.acf?.large_title_2 && !isLoading">{{ accesstList.acf?.large_title_2 }}</h2>
            <p v-if="accesstList.acf?.large_text_2 && !isLoading" v-html="accesstList.acf?.large_text_2"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="accesstList.acf?.display_name_2">
              <a :href="accesstList.acf?.url_2" :target="accesstList.acf?.operation_at_transition_2 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ accesstList.acf?.display_name_2 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>

          <div :ref="accesstList.acf?.large_title_3" :id="accesstList.acf?.large_title_3" class="access__content content--1 current" v-if="accesstList.acf?.large_title_3 || accesstList.acf?.large_text_3 || accesstList.acf?.large_image_3">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="accesstList.acf?.large_image_3 && !isLoading"
                :src="$func.formatUrl(accesstList.acf?.large_image_3)" 
                :alt="accesstList.acf?.large_title_3"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="accesstList.acf?.large_title_3 && !isLoading">{{ accesstList.acf?.large_title_3 }}</h2>
            <p v-if="accesstList.acf?.large_text_3 && !isLoading" v-html="accesstList.acf?.large_text_3"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="accesstList.acf?.display_name_3">
              <a :href="accesstList.acf?.url_3" :target="accesstList.acf?.operation_at_transition_3 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ accesstList.acf?.display_name_3 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>

          <div :id="accesstList.acf?.large_title_4" class="access__content content--1 current" v-if="accesstList.acf?.large_title_4 || accesstList.acf?.large_text_4 || accesstList.acf?.large_image_4">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="accesstList.acf?.large_image_4 && !isLoading"
                :src="$func.formatUrl(accesstList.acf?.large_image_4)" 
                :alt="accesstList.acf?.large_title_4"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="accesstList.acf?.large_title_4 && !isLoading">{{ accesstList.acf?.large_title_4 }}</h2>
            <p v-if="accesstList.acf?.large_text_4 && !isLoading" v-html="accesstList.acf?.large_text_4"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="accesstList.acf?.display_name_4">
              <a :href="accesstList.acf?.url_4" :target="accesstList.acf?.operation_at_transition_4 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ accesstList.acf?.display_name_4 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>

          <div :id="accesstList.acf?.large_title_5" class="access__content content--1 current" v-if="accesstList.acf?.large_title_5 || accesstList.acf?.large_text_5 || accesstList.acf?.large_image_5">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="accesstList.acf?.large_image_5 && !isLoading"
                :src="$func.formatUrl(accesstList.acf?.large_image_5)" 
                :alt="accesstList.acf?.large_title_5"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="accesstList.acf?.large_title_5 && !isLoading">{{ accesstList.acf?.large_title_5 }}</h2>
            <p v-if="accesstList.acf?.large_text_5 && !isLoading" v-html="accesstList.acf?.large_text_5"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="accesstList.acf?.display_name_5">
              <a :href="accesstList.acf?.url_5" :target="accesstList.acf?.operation_at_transition_5 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ accesstList.acf?.display_name_5 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>

          <div :id="accesstList.acf?.large_title_6" class="access__content content--1 current" v-if="accesstList.acf?.large_title_6 || accesstList.acf?.large_text_6 || accesstList.acf?.large_image_6">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="accesstList.acf?.large_image_6 && !isLoading"
                :src="$func.formatUrl(accesstList.acf?.large_image_6)" 
                :alt="accesstList.acf?.large_title_6"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="accesstList.acf?.large_title_6 && !isLoading">{{ accesstList.acf?.large_title_6 }}</h2>
            <p v-if="accesstList.acf?.large_text_6 && !isLoading" v-html="accesstList.acf?.large_text_6"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="accesstList.acf?.display_name_6">
              <a :href="accesstList.acf?.url_6" :target="accesstList.acf?.operation_at_transition_6 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ accesstList.acf?.display_name_6 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>

          <div :id="accesstList.acf?.large_title_7" class="access__content content--1 current" v-if="accesstList.acf?.large_title_7 || accesstList.acf?.large_text_7 || accesstList.acf?.large_image_7">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="accesstList.acf?.large_image_7 && !isLoading"
                :src="$func.formatUrl(accesstList.acf?.large_image_7)" 
                :alt="accesstList.acf?.large_title_7"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="accesstList.acf?.large_title_7 && !isLoading">{{ accesstList.acf?.large_title_7 }}</h2>
            <p v-if="accesstList.acf?.large_text_7 && !isLoading" v-html="accesstList.acf?.large_text_7"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="accesstList.acf?.display_name_7">
              <a :href="accesstList.acf?.url_7" :target="accesstList.acf?.operation_at_transition_7 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ accesstList.acf?.display_name_7 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>

          <div :id="accesstList.acf?.large_title_8" class="access__content content--1 current" v-if="accesstList.acf?.large_title_8 || accesstList.acf?.large_text_8 || accesstList.acf?.large_image_8">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="accesstList.acf?.large_image_8 && !isLoading"
                :src="$func.formatUrl(accesstList.acf?.large_image_8)" 
                :alt="accesstList.acf?.large_title_8"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="accesstList.acf?.large_title_8 && !isLoading">{{ accesstList.acf?.large_title_8 }}</h2>
            <p v-if="accesstList.acf?.large_text_8 && !isLoading" v-html="accesstList.acf?.large_text_8"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="accesstList.acf?.display_name_8">
              <a :href="accesstList.acf?.url_8" :target="accesstList.acf?.operation_at_transition_8 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ accesstList.acf?.display_name_8 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>

          <div :id="accesstList.acf?.large_title_9" class="access__content content--1 current" v-if="accesstList.acf?.large_title_9 || accesstList.acf?.large_text_9 || accesstList.acf?.large_image_9">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="accesstList.acf?.large_image_9 && !isLoading"
                :src="$func.formatUrl(accesstList.acf?.large_image_9)" 
                :alt="accesstList.acf?.large_title_9"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="accesstList.acf?.large_title_9 && !isLoading">{{ accesstList.acf?.large_title_9 }}</h2>
            <p v-if="accesstList.acf?.large_text_9 && !isLoading" v-html="accesstList.acf?.large_text_9"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="accesstList.acf?.display_name_9">
              <a :href="accesstList.acf?.url_9" :target="accesstList.acf?.operation_at_transition_9 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ accesstList.acf?.display_name_9 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>

          <div :id="accesstList.acf?.large_title_10" class="access__content content--1 current" v-if="accesstList.acf?.large_title_10 || accesstList.acf?.large_text_10 || accesstList.acf?.large_image_10">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="accesstList.acf?.large_image_10 && !isLoading"
                :src="$func.formatUrl(accesstList.acf?.large_image_10)" 
                :alt="accesstList.acf?.large_title_10"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="accesstList.acf?.large_title_10 && !isLoading">{{ accesstList.acf?.large_title_10 }}</h2>
            <p v-if="accesstList.acf?.large_text_10 && !isLoading" v-html="accesstList.acf?.large_text_10"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="accesstList.acf?.display_name_10">
              <a :href="accesstList.acf?.url_10" :target="accesstList.acf?.operation_at_transition_10 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ accesstList.acf?.display_name_10 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>
          <div class="cont-bottom"
            v-if="accesstList.acf?.medium_title ||  accesstList.acf?.medium_subtitle || accesstList.acf?.medium_text_1 || accesstList.acf?.medium_text_2 ||
            accesstList.acf?.small_title_1 || accesstList.acf?.small_image_1 || accesstList.acf?.small_text_1 ||
            accesstList.acf?.small_title_2 || accesstList.acf?.small_image_2 || accesstList.acf?.small_text_2 ||
            accesstList.acf?.small_title_3 || accesstList.acf?.small_image_3 || accesstList.acf?.small_text_3 ||
            accesstList.acf?.small_title_4 || accesstList.acf?.small_image_4 || accesstList.acf?.small_text_4 ||
            accesstList.acf?.small_title_5 || accesstList.acf?.small_image_5 || accesstList.acf?.small_text_5 ||
            accesstList.acf?.small_title_6 || accesstList.acf?.small_image_6 || accesstList.acf?.small_text_6 ||
            accesstList.acf?.small_title_7 || accesstList.acf?.small_image_7 || accesstList.acf?.small_text_7 ||
            accesstList.acf?.small_title_8 || accesstList.acf?.small_image_8 || accesstList.acf?.small_text_8 ||
            accesstList.acf?.small_title_9 || accesstList.acf?.small_image_9 || accesstList.acf?.small_text_9 ||
            accesstList.acf?.small_title_10 || accesstList.acf?.small_image_10 || accesstList.acf?.small_text_10
          ">
            <h2 v-if="accesstList.acf?.medium_title || accesstList.acf?.medium_subtitle">
              {{ accesstList.acf?.medium_title}}<span>{{ accesstList.acf?.medium_subtitle }}</span>
            </h2>
            <p v-if="accesstList.acf?.medium_text_1" v-html="accesstList.acf?.medium_text_1"></p>
            <p v-if="accesstList.acf?.medium_text_2" v-html="accesstList.acf?.medium_text_2"></p>
            <div class="cont__list">
              <div class="cont__list__child" v-if="accesstList.acf?.small_title_1 || accesstList.acf?.small_image_1 || accesstList.acf?.small_text_1">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="accesstList.acf?.small_image_1"
                      :src="$func.formatUrl(accesstList.acf?.small_image_1)" 
                      :alt="accesstList.acf?.small_title_1" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="accesstList.acf?.small_title_1">{{ accesstList.acf?.small_title_1 }}</h3>
                  <p v-if="accesstList.acf?.small_text_1" v-html="accesstList.acf?.small_text_1"></p>
                </div>
              </div>

              <div class="cont__list__child"  v-if="accesstList.acf?.small_title_2 || accesstList.acf?.small_image_2 || accesstList.acf?.small_text_2">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="accesstList.acf?.small_image_2"
                      :src="$func.formatUrl(accesstList.acf?.small_image_2)" 
                      :alt="accesstList.acf?.small_title_2" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="accesstList.acf?.small_title_2">{{ accesstList.acf?.small_title_2 }}</h3>
                  <p v-if="accesstList.acf?.small_text_2" v-html="accesstList.acf?.small_text_2"></p>
                </div>
              </div>

              <div class="cont__list__child"  v-if="accesstList.acf?.small_title_3 || accesstList.acf?.small_image_3 || accesstList.acf?.small_text_3">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="accesstList.acf?.small_image_3"
                      :src="$func.formatUrl(accesstList.acf?.small_image_3)" 
                      :alt="accesstList.acf?.small_title_3" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="accesstList.acf?.small_title_3">{{ accesstList.acf?.small_title_3 }}</h3>
                  <p v-if="accesstList.acf?.small_text_3" v-html="accesstList.acf?.small_text_3"></p>
                </div>
              </div>

              <div class="cont__list__child"  v-if="accesstList.acf?.small_title_4 || accesstList.acf?.small_image_4 || accesstList.acf?.small_text_4">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="accesstList.acf?.small_image_4"
                      :src="$func.formatUrl(accesstList.acf?.small_image_4)" 
                      :alt="accesstList.acf?.small_title_4" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="accesstList.acf?.small_title_4">{{ accesstList.acf?.small_title_4 }}</h3>
                  <p v-if="accesstList.acf?.small_text_4" v-html="accesstList.acf?.small_text_4"></p>
                </div>
              </div>

              <div class="cont__list__child"  v-if="accesstList.acf?.small_title_5 || accesstList.acf?.small_image_5 || accesstList.acf?.small_text_5">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="accesstList.acf?.small_image_5"
                      :src="$func.formatUrl(accesstList.acf?.small_image_5)" 
                      :alt="accesstList.acf?.small_title_5" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="accesstList.acf?.small_title_5">{{ accesstList.acf?.small_title_5 }}</h3>
                  <p v-if="accesstList.acf?.small_text_5" v-html="accesstList.acf?.small_text_5"></p>
                </div>
              </div>

              <div class="cont__list__child"  v-if="accesstList.acf?.small_title_6 || accesstList.acf?.small_image_6 || accesstList.acf?.small_text_6">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="accesstList.acf?.small_image_6"
                      :src="$func.formatUrl(accesstList.acf?.small_image_6)" 
                      :alt="accesstList.acf?.small_title_6" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="accesstList.acf?.small_title_6">{{ accesstList.acf?.small_title_6 }}</h3>
                  <p v-if="accesstList.acf?.small_text_6" v-html="accesstList.acf?.small_text_6"></p>
                </div>
              </div>

              <div class="cont__list__child"  v-if="accesstList.acf?.small_title_7 || accesstList.acf?.small_image_7 || accesstList.acf?.small_text_7">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="accesstList.acf?.small_image_7"
                      :src="$func.formatUrl(accesstList.acf?.small_image_7)" 
                      :alt="accesstList.acf?.small_title_7" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="accesstList.acf?.small_title_7">{{ accesstList.acf?.small_title_7 }}</h3>
                  <p v-if="accesstList.acf?.small_text_7" v-html="accesstList.acf?.small_text_7"></p>
                </div>
              </div>

              <div class="cont__list__child"  v-if="accesstList.acf?.small_title_8 || accesstList.acf?.small_image_8 || accesstList.acf?.small_text_8">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="accesstList.acf?.small_image_8"
                      :src="$func.formatUrl(accesstList.acf?.small_image_8)" 
                      :alt="accesstList.acf?.small_title_8" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="accesstList.acf?.small_title_8">{{ accesstList.acf?.small_title_8 }}</h3>
                  <p v-if="accesstList.acf?.small_text_8" v-html="accesstList.acf?.small_text_8"></p>
                </div>
              </div>

              <div class="cont__list__child"  v-if="accesstList.acf?.small_title_9 || accesstList.acf?.small_image_9 || accesstList.acf?.small_text_9">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="accesstList.acf?.small_image_9"
                      :src="$func.formatUrl(accesstList.acf?.small_image_9)" 
                      :alt="accesstList.acf?.small_title_9" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="accesstList.acf?.small_title_9">{{ accesstList.acf?.small_title_9 }}</h3>
                  <p v-if="accesstList.acf?.small_text_9" v-html="accesstList.acf?.small_text_9"></p>
                </div>
              </div>

              <div class="cont__list__child"  v-if="accesstList.acf?.small_title_10 || accesstList.acf?.small_image_10 || accesstList.acf?.small_text_10">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="accesstList.acf?.small_image_10"
                      :src="$func.formatUrl(accesstList.acf?.small_image_10)" 
                      :alt="accesstList.acf?.small_title_10" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="accesstList.acf?.small_title_10">{{ accesstList.acf?.small_title_10 }}</h3>
                  <p v-if="accesstList.acf?.small_text_10" v-html="accesstList.acf?.small_text_10"></p>
                </div>
              </div>

            </div>
          </div>

        </div>
        
      </div>
    </div>
  </main>
</template>

<script>
import CONSTANT from "@/constant";
import { RouterLink } from "vue-router";
import { getUrl, metaData } from '@/utils/helper';

export default {
  name: "Access",
  components: {
    AccessMenu: () => import("@/components/common/AccessMenu.vue"),
  },
  data() {
    return {
      accessMenu: CONSTANT.dataAccessMenu,
      accesstList: {},
      isLoading: true,
      isActive: '',
    };
  },
  mounted() {
    // let getID = this.$route.params.id;
    // this.scrollTo(getID);

    // console.log(this.$route.params.id)
  },
  computed: {},
  methods: {
    isActiveF(title) {
      this.isActive = title;
      var element_to_scroll_to = document.getElementById(title);
      element_to_scroll_to.scrollIntoView();
      this.activeCurrentTab(title);
    },
    activeCurrentTab(title) {
      Array.from(document.querySelectorAll('.access__tab__item')).forEach(function(el) { 
        el.classList.remove('current');
      });

      document.getElementById(`tab_${title}`).classList.add('current');
    }
  },
  created() {
    this.isLoading = true;
    getUrl(`/access/${process.env.VUE_APP_ID_ACCESS}`)
    .then((response) => {
      this.accesstList = response.data;

      metaData(
        `${this.accesstList.acf?.page_title ? this.accesstList.acf?.page_title : 'アクセス'} | HARUMIFLAGタウンポータル`,
        '中央区晴海・HARUMIFLAGのアクセス（マルチモビリティステーション）のご紹介です。',
        'HARUMIFLAGタウンポータル',
        'article'
      )
    
      this.isLoading = false;
    })
    .catch((e) => {
      console.log(e);
      this.$router.push('/timeout')
    })
    .finally(() => {
      const accessKey = localStorage.getItem('accessKey')
      if (accessKey) {
        setTimeout(() => {
          this.isActive = accessKey;
          var element_to_scroll_to = document.getElementById(accessKey);
          element_to_scroll_to.scrollIntoView();
          localStorage.removeItem('accessKey')
          this.activeCurrentTab(accessKey);
        }, 1500)
      }
    });
  }
};
</script>